<template>
  <div>
    <a-tree
        v-model:checkedKeys="checkedKeys"
        :treeData="tree"
        :block-node="true"
        :field-names="{ key: 'id' }"
        :checkable="true"
    />
  </div>
</template>

<script lang="ts" setup>
import {computed, defineProps, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {CustomFieldType} from "@/components/business/crud/interface/FieldType";
import {app} from "@/models/App";

const props = defineProps<{
  propName: string;
  widget: CustomFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

function getShow(node: any, keys: string[]) {
  if (node.children.length > 0) {
    node.children.map((child: any) => getShow(child, keys));
  } else if ((data.value[props.propName] as string[] | undefined)?.some(i => node.id === i)) {
    keys.push(node.id);
  }
}


const tree = ref(app.data.authRule)

const checkedKeys = computed({
  get(): string[] {
    const keys: string[] = [];
    tree.value.map((node: any) => getShow(node, keys));
    console.log(tree)
    return keys;
  },
  set(val: any) {
    if (props.info.status === 'edit') {
      data.value[props.propName] = val;
    }
  },
})

</script>